import { Component } from '@angular/core';
import {
	ActionSheet,
	ActionSheetController,
	IonicPage,
	LoadingController,
	ModalController,
	NavController,
	NavParams,
	ToastController
} from 'ionic-angular';
import { iConfiguracion } from '../../models/basePage';
import { Online } from '../../models/online/cfutbol';
import { PaginaBasica } from '../../models/PaginaBase';
import { APIOnLine } from '../../services/api/api.services';
import { Proxy } from '../../services/proxy/proxy.service';
import { AlineacionPage } from '../alineacion/alineacion';
import { FinalizarPage } from '../finalizar/finalizar';
import { ResultadoPage } from '../resultado/resultado';

/**
 * Generated class for the DeclaracionesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
	selector: 'page-declaraciones',
	templateUrl: 'declaraciones.html'
})
export class DeclaracionesPage extends PaginaBasica {
	//#region
	public arbitros: Online.IArbitroDTO[] = [];
	public configuraciones: iConfiguracion;
	public designacion: Proxy.PrDesignaciones;
	public declaraciones: Online.DeclaracionesCOVIDDesignacion[];
	public pagina: string; // Indica a la página que debe ir cuando se completen todas las declaraciones.
	//#endregion

	constructor(
		public actionSheetCtrl: ActionSheetController,
		public navCtrl: NavController,
		public navParams: NavParams,
		public toastCtrl: ToastController,
		public loadingCtrl: LoadingController,
		public modalCtrl: ModalController,
		public CFutbolActas: APIOnLine.CFutbolActas,
		public DeclaracionesCOVIDDesignacionService: APIOnLine.DeclaracionesCOVIDDesignacionService,
		public Persistentes: APIOnLine.Persistentes
	) {
		super(loadingCtrl, toastCtrl);
	}

	ionViewDidLoad() {
		console.log('ionViewDidLoad DeclaracionesPage');

		this.pagina = <string>this.navParams.get('pagina');

		let promesas: Promise<Online.IArbitroDTO>[] = [];
		this.designacion = this.Persistentes.GetDesignacion();
		this.declaraciones = this.Persistentes.GetDeclaraciones();
		this.MostrarOcultarCarga();

		// Obtención de los datos de cada uno de los árbitros;
		this.declaraciones.forEach((valor: Online.DeclaracionesCOVIDDesignacion) => {
			promesas.push(this.CFutbolActas.datosArbitro(valor.idArbitro, this.designacion.urlApi));
		});

		Promise.all(promesas)
			.then((resultado: Online.IArbitroDTO[]) => {
				this.arbitros = resultado;
				console.log(resultado);
				this.MostrarOcultarCarga();
			})
			.catch((error) =>
				this.Error(JSON.stringify(error), 'ERROR: Obteniendo la información de los árbitros de la designación.')
			);
	}

	ionViewDidEnter() {}

	//#region Métodos de la clase

	private ComprobarDeclaraciones(): void {
		if (!this.ComprobarPositivo() && this.declaraciones.filter((m) => m.id == 0).length == 0) {
			this.navCtrl.pop().then(() => {
				this.Persistentes.SetDesignacion(this.designacion, this.designacion.idLocal);

				this.MostrarOcultarCarga(true);
				switch (this.pagina) {
					case 'Alineacion':
						this.navCtrl.push(AlineacionPage);
						break;
					case 'Finalizar':
						this.navCtrl.push(FinalizarPage, {
							idDesignacion: this.designacion.idDesignacion
						});
						break;
					case 'Resultado':
						this.navCtrl.push(ResultadoPage, {
							idDesignacion: this.designacion.idDesignacion
						});
						break;
				}
			});
		}
	}

	/**
   * Indica si en alguna de las declaraciones se ha indicado un positivo.
   */
	private ComprobarPositivo(): boolean {
		if (this.declaraciones != null && this.declaraciones.length > 0) {
			return this.declaraciones.filter((m) => m.cercania == true || m.sintomas == true).length > 0 ? true : false;
		} else {
			return false;
		}
	}

	public Confirmar(declaracion: Online.DeclaracionesCOVIDDesignacion, tipo: string): void {
		let actionSheet: ActionSheet = this.actionSheetCtrl.create({
			title: 'Confirmar positivo',
			subTitle: '¿Confirma la situación de positivo?',
			buttons: [
				{
					text: 'Confirmar',
					handler: () => {
						switch (tipo) {
							case 'cercania':
								declaracion.cercania = true;
								break;
							case 'sintomas':
								declaracion.sintomas = true;
								break;
						}
					}
				},
				{
					text: 'Cancelar',
					role: 'cancel',
					handler: () => {
						declaracion.cercania = undefined;
					}
				}
			]
		});
		actionSheet.present();
	}

	public EnviarDeclaracion(declaracion: Online.DeclaracionesCOVIDDesignacion): void {
		// Se comprueba que la declaración no tenga un valor de undefined en la cercanía o los síntomas
		if (declaracion.cercania == undefined || declaracion.sintomas == undefined) {
			this.Mensaje('Debe seleccionar uno de los dos valores posibles en cada una de las dos preguntas', 7000);
		} else {
			this.MostrarOcultarCarga();
			this.DeclaracionesCOVIDDesignacionService
				.post(declaracion, this.designacion.urlApi)
				.then((resultado: Online.DeclaracionesCOVIDDesignacion) => {
					this.declaraciones = this.declaraciones.map((m) => {
						if (m.idArbitro == resultado.idArbitro) {
							return resultado;
						} else {
							return m;
						}
					});
					this.MostrarOcultarCarga();
					this.ComprobarDeclaraciones();

					// Se comprueba si se ha producido algún positivo, para reenviar la página al estado anterior, indicando que está bloqueada la designación
					if (this.ComprobarPositivo()) {
						this.designacion.bloqueada = true;
						this.Persistentes.SetDesignacion(this.designacion);
						this.navCtrl.pop();
					}
				})
				.catch((error) => this.Error(JSON.stringify(error), 'ERROR: Guardando los datos de la declaración.'));
		}
	}

	public NombreArbitro(idArbitro: number): string {
		let resultado: string = '';

		if (this.arbitros != null) {
			this.arbitros.forEach((arbitro: Online.IArbitroDTO) => {
				if (arbitro.idArbitro == idArbitro) {
					resultado =
						arbitro.nombre.trim() +
						' ' +
						arbitro.apellido1.trim() +
						' ' +
						(arbitro.apellido2 != null ? arbitro.apellido2.trim() : '');
				}
			});
		}

		return resultado;
	}

	//#endregion
}



// WEBPACK FOOTER //
// ./src/pages/declaraciones/declaraciones.ts